export default "__VITE_ASSET__DysJ6XVn__"